import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class HudHelmets extends Phaser.GameObjects.Container {
  constructor(scene, cont) {
    super(scene);
    cont ? cont.add(this) : scene.add.existing(this);

    this.scene = scene;
    let curx = 0;
    this.helmets = [];
    this.xes = [];

    let item = ABCyaPhaser.Images.addImage(0, 0, 'HelmetIcon', this).setOrigin(0, 0);
    item.x = curx;
    this.helmets.push(item);

    item = ABCyaPhaser.Images.addImage(0, 0, 'HelmetIconX', this);
    item.alpha = 0;
    item.x = curx + 2 + item.getBounds().width / 2;
    item.y = 2 + item.getBounds().height / 2;
    this.xes.push(item);
    curx += item.getBounds().width + 20;

    item = ABCyaPhaser.Images.addImage(0, 0, 'HelmetIcon', this).setOrigin(0, 0);
    item.x = curx;
    this.helmets.push(item);

    item = ABCyaPhaser.Images.addImage(0, 0, 'HelmetIconX', this);
    item.alpha = 0;
    item.x = curx + 2 + item.getBounds().width / 2;
    item.y = 2 + item.getBounds().height / 2;
    this.xes.push(item);
    curx += item.getBounds().width + 20;

    item = ABCyaPhaser.Images.addImage(0, 0, 'HelmetIcon', this).setOrigin(0, 0);
    item.x = curx;
    this.helmets.push(item);

    item = ABCyaPhaser.Images.addImage(0, 0, 'HelmetIconX', this);
    item.alpha = 0;
    item.x = curx + 2 + item.getBounds().width / 2;
    item.y = 2 + item.getBounds().height / 2;
    this.xes.push(item);
  }

  helmetGone(whichone) {
    const x = this.xes[Math.abs(whichone - 2)];
    x.alpha = 0;
    x.scale = 2.4;

    ABCyaPhaser.Tweens.addTween(x, 600, { scale: 1, alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);
  };
}